<template>
    <div class="cryptoWIthdrawContainer">
        <div v-if="!userStore.withdrawPassword">
            <div class="textTitle"> {{ $t('profile.withdrawalPassword') }}</div>
            <div class="crypto_field">
                <div>{{ $t('withdraw.securityPassword') }}</div>
                <van-field v-model="newPassword" :type="isShow ? 'text' : 'password'"
                    :placeholder="$t('profile.enterNewPassword')">
                    <template #right-icon>
                        <div>
                            <img v-if="isShow" src="@/assets/loginRegister/showEye.png" alt="" width="18px"
                                class="iconImage" @click="handleShowPassword" />
                            <img v-else src="@/assets/loginRegister/hideEye.png" alt="" width="18px" class="iconImage"
                                @click="handleShowPassword" />
                        </div>
                    </template>
                </van-field>
                <div v-if="passwordValidationNotice" class="errorNotice">
                    {{ $t('loginRegister.passwordForamtNew') }}
                </div>
            </div>
            <div class="crypto_field">
                <div>{{ $t('profile.cnofirmNewPassword') }}</div>
                <van-field v-model="confirmPassword" :type="isShowconfirm ? 'text' : 'password'"
                    :placeholder="$t('profile.cnofirmNewPassword')">
                    <template #right-icon>
                        <div>
                            <img v-if="isShowconfirm" src="@/assets/loginRegister/showEye.png" alt="" width="18px"
                                class="iconImage" @click="handleShowPassword" />
                            <img v-else src="@/assets/loginRegister/hideEye.png" alt="" width="18px" class="iconImage"
                                @click="handleShowConfirmPassword" />
                        </div>
                    </template>
                </van-field>
                <div v-if="confirmPassword && newPassword && confirmPassword !== newPassword" class="errorNotice">
                    {{ $t('loginRegister.differentPassword') }}
                </div>
            </div>
            <div class="btn_container">
                <MainButton :title="$t('profile.save')" :activeStatus="isSubmitBtnActivated"
                    @click="handleUpdatePassword" />
            </div>

        </div>
        <div v-else>
            <div class="crypto_field">
                <div>{{ $t('withdraw.address') }}</div>
                <van-field v-model="address" :placeholder="$t('withdraw.address')">
                    <template #right-icon>
                        <div class="right_Icons">
                            <van-icon name="user-circle-o" color="#f1bae0" size="22" style="padding-right: 15px;"
                                @click="showAddressPopup" />
                            <van-icon name="scan" size="22" color="#f1bae0" @click="handleStartScan" />
                        </div>
                    </template>
                </van-field>
            </div>
            <div class="crypto_field">
                <div>{{ $t('withdraw.network') }}</div>
                <div class="networkField" @click="showNetworkPopup">{{ network ? network : $t('withdraw.network') }}
                </div>
            </div>
            <div class="crypto_field">
                <div>{{ $t('withdraw.securityPassword') }}</div>
                <van-field v-model="securityPassword" type="password"
                    :placeholder="$t('withdraw.securityPassword')"></van-field>
            </div>
            <div class="crypto_field">
                <div>{{ $t('withdraw.withdrawalAmount') }}</div>
                <van-field v-model="withdrawalAmount" type="number"
                    :placeholder="$t('withdraw.withdrawalMinAmount', { value: withdrawMin })">
                    <template #right-icon>
                        <div class="rightText"> USDT <span>Max</span></div>
                    </template>
                </van-field>
            </div>
            <!-- <van-row class="availableAmountText">
            <van-col span="12">{{ $t('withdraw.availableBalance') }}</van-col>
            <van-col span="12" style="display: flex; justify-content: right;">
                <div class="rightText"> USDT <span>{{ formatCurrency(availableBalance) }}</span></div>
            </van-col>
        </van-row> -->

            <div class="btn_container">
                <MainButton :title="$t('common.sake')" :activeStatus="buttonActive" @click="confirmWithdraw" />
            </div>
        </div>

        <van-popup v-model:show="showScanner" class="transparent-scanner-popup" @closed="stopScanner"
            :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }">
            <div class="scanner-wrapper">
                <div id="reader"></div>
            </div>
        </van-popup>
        <AddressBookPopup ref="addressBookPopupRef" />
        <NetworkSelectPopup ref="networkPopupRef" :networkList="networkList" @selectNetwork="setSelecteddNetwork" />
        <LoadingScreen ref="loadingRef" />
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    </div>
</template>

<script setup lang="ts">
import { formatCurrency } from '@/utils/commonFunction';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import MainButton from '../components/common/mainButton.vue';
import AddressBookPopup from './components/addressBookPopup.vue';
import NetworkSelectPopup from './components/networkSelectPopup.vue';
import { callNetworkOptions, callWithdraw, useScanner } from '@/view/withdraw/supportScript';
import { useUserStore } from '@/stores/user';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { checkConfirmPasswordValidation, checkWithdrawPasswordValidation, updateWithdrawPassword } from '@/view/profile/supportScript';

const userStore = useUserStore()
const address = ref('')
const network = ref('')
const securityPassword = ref('')
const withdrawalAmount = ref('')
const withdrawMin = ref(0)
const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
// const availableBalance = ref(0)
const addressBookPopupRef = ref()
const networkPopupRef = ref()
const networkList = ref([])
const selectedNetwork = ref<any>({})
const uId = ref(userStore.id)

const isShow = ref(false)
const isShowconfirm = ref(false)
const newPassword = ref('')
const confirmPassword = ref('')
const passwordValidationNotice = ref(false)
const confirmPasswordValidationNotice = ref(false)
const isSubmitBtnActivated = computed(() => {
    return (
        newPassword.value.length > 0 &&
        confirmPassword.value.length > 0 &&
        !passwordValidationNotice.value &&
        !confirmPasswordValidationNotice.value &&
        newPassword.value === confirmPassword.value
    );
})
const passwordChange = (value: string) => {
    newPassword.value = value
    checkWithdrawPasswordValidation(value, passwordValidationNotice)
    checkConfirmPasswordValidation(confirmPassword.value, confirmPassword, newPassword, confirmPasswordValidationNotice)
}

const confirmPasswordChange = (value: string) => {
    confirmPassword.value = value
    checkConfirmPasswordValidation(value, confirmPassword, newPassword, confirmPasswordValidationNotice)
}
const handleUpdatePassword = () => {
    updateWithdrawPassword('', newPassword.value, ref(false), toastContent, isSuccess, statusRef)
}
const handleShowPassword = () => {
    isShow.value = !isShow.value
}
const handleShowConfirmPassword = () => {
    isShowconfirm.value = !isShowconfirm.value
}

const buttonActive = computed(() => {
    return (
        address.value.trim() !== '' &&
        network.value.trim() !== '' &&
        securityPassword.value.trim() !== '' &&
        withdrawalAmount.value !== '' &&
        Number(withdrawalAmount.value) > 0
    );
});
const { showScanner, startScanner, stopScanner } = useScanner();

const handleStartScan = () => {
    startScanner('reader', (result) => {
        address.value = result;
    });
};

const showAddressPopup = () => {
    addressBookPopupRef.value.openPopup()
}

const showNetworkPopup = () => {
    networkPopupRef.value.openPopup()
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const confirmWithdraw = async () => {
    loadingRef.value.open()
    const { data } = await callWithdraw(address.value, uId.value, withdrawalAmount.value, selectedNetwork.value.id, securityPassword.value)
    if (data.code == 200) {
        loadingRef.value.close()
        showSuccess(data.msg)
    } else {
        loadingRef.value.close()
        showError(data)
    }
}

const getNetworkOption = async (addr?: string) => {
    if (addr) {
        address.value = addr
    }

    const { network_list } = await callNetworkOptions(address.value)
    networkList.value = network_list

}

const setSelecteddNetwork = (networkData: any) => {
    selectedNetwork.value = networkData
    network.value = networkData?.channelName
    networkPopupRef.value.closePopup()
}
watch(() => address.value, (newVal) => {
    getNetworkOption()
    network.value = ''
})

watch(() => newPassword.value, (val) => {
    passwordChange(val)
})
watch(() => confirmPassword.value, (val) => {
    confirmPasswordChange(val)
})
onUnmounted(() => {
    stopScanner();
});
onMounted(() => {
    getNetworkOption()
})
</script>
<style scoped>
.cryptoWIthdrawContainer {
    padding: 25px;
}

.textTitle {
    padding: 10px;
    font-size: 16px;
    text-align: center;
    font-weight: 600;
}

.errorNotice {
    color: #E00000;
    font-size: 15px;
    padding: 0 15px;
}
.crypto_field {
    color: #f1bae0;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 25px;
}

.networkField {
    background: #2c1d31 !important;
    border: 1px solid #65436f;
    border-radius: 0.5rem;
    margin-top: 5px;
    padding: 14px 15px;
    color: #c6c1c1;
    font-weight: 400;
}

.van-cell {
    background: #2c1d31 !important;
    border: 1px solid #65436f;
    border-radius: 0.5rem;
    margin-top: 5px;
}

.right_Icons {
    display: flex;
}

.rightText {
    color: rgb(248, 189, 28);
    font-weight: bold;
}

.rightText span {
    color: #fff;
    font-weight: 400;
    padding-left: 5px;
}

.availableAmountText {
    color: #fff;
    font-size: 14px;
    padding-right: 15px;
}

.btn_container {
    padding: 30px 10%;
}

.crypto_field :deep(.van-field__control) {
    color: #fff !important;
    font-weight: 400 !important;
}

.btn_container ::v-deep .defaultButton .van-button--default {
    border-radius: 10px !important;
    padding: 1.5vw 0;
}

.transparent-scanner-popup {
    background: transparent !important;
    overflow: visible;
    width: 80%;
    /* Width of the camera view on screen */
}

.scanner-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

#reader {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    background: #000;
}

:deep(#reader video) {
    width: 100% !important;
    height: auto !important;
    object-fit: cover;
}

:deep(#reader img) {
    display: none !important;
}

:deep(#reader button) {
    display: none !important;
}
</style>